import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Computer } from "@resources";
import { helpers } from "@shared";

const InformationSafety = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const next = () => {
        helpers.navigateNext(location, navigate);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Your information is safe with Sunbound</h1>
            <Computer className="h-56" />
            <div className="page-subheader font-black text-black">Sunbound believes protecting our members&apos; personal information is critical.</div>
            <div className="page-subheader">Sunbound uses industry leading information security practices to safeguard against potential threats.</div>
            <div className="page-subheader">Your personal information is used only for what is absolutely necessary and we never sell data to a third-party.</div>
            <div className="page-subheader">Please see our <a className="underline text-blue-600" href="https://www.sunboundhomes.com/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a> for more information.</div>
            <div className="page-action">
                <button type="button" className="btn btn-primary" onClick={next}>Continue</button>
            </div>
        </div>
    );
};

export default InformationSafety;
